import axios from 'axios'
import LocalStorageService from './LocalStorageService'

export default function apiFactory (baseURL = LocalStorageService.getAccessUrl()) {
  const authorization = LocalStorageService.getAuthorization()

  return axios.create({
    baseURL,
    headers: { authorization },
    paramsSerializer: (params) => new URLSearchParams(params)
  })
}
